import { Mail, Linkedin } from "lucide-react";
import { Reveal, Chapter } from "@/components/portfolio/motion";
import { XIcon, DiscordIcon } from "@/components/portfolio/icons";

const EMAIL = "rishi18007@gmail.com";

const SOCIALS = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/rishisshah/",
    icon: <Linkedin className="w-5 h-5" />,
    testId: "social-linkedin-link",
  },
  {
    label: "X",
    href: "https://x.com/rishi18007",
    icon: <XIcon className="w-5 h-5" />,
    testId: "social-x-link",
  },
];

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="scroll-mt-20 max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28 border-t border-line"
  >
    <Chapter num="06 / Contact" label="Contact" testId="contact-chapter" />

    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
      <div className="md:col-span-7">
        <Reveal>
          <p className="font-display text-2xl sm:text-3xl font-bold text-ink leading-snug max-w-xl">
            Let's talk, about a role, a project, or just AI and games.
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <a
            data-testid="contact-email-text"
            href={`mailto:${EMAIL}`}
            className="mt-6 inline-block text-lg text-accent hover:text-accent-hover underline underline-offset-4 decoration-accent/40 transition-colors"
          >
            {EMAIL}
          </a>
        </Reveal>
        <Reveal delay={0.14}>
          <div className="mt-8">
            <a
              data-testid="contact-email-button"
              href={`mailto:${EMAIL}`}
              className="group inline-flex items-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-medium text-white hover:bg-accent-hover transition-colors"
            >
              <Mail className="w-4 h-4" /> Email me
            </a>
          </div>
        </Reveal>
      </div>

      <div className="md:col-span-5 md:pt-2">
        <Reveal delay={0.1}>
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-muted mb-5">
            Find me elsewhere
          </p>
          <div className="flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                data-testid={s.testId}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-line text-ink hover:bg-accent hover:text-white hover:border-accent transition-all duration-300"
              >
                {s.icon}
              </a>
            ))}
            <span
              data-testid="social-discord"
              aria-label="Discord available on request"
              className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-line text-muted"
            >
              <DiscordIcon className="w-5 h-5" />
            </span>
          </div>
          <p className="mt-4 text-sm text-muted">Discord available on request.</p>
        </Reveal>
      </div>
    </div>

    <div className="mt-20 pt-8 border-t border-line flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <p className="font-display font-extrabold text-ink">
        Rishi Shah<span className="text-accent">.</span>
      </p>
      <p className="text-sm text-muted">
        Built with AI tools, the same way I work. © {new Date().getFullYear()}
      </p>
    </div>
  </section>
);
